<template>
    <custom-container-full :budget-data="budgetData">
        <div class="main-week-select">
            <h4 class="c-question c-question-first">¿En qué semana deseas recibir la planta?</h4>
            <p>
                El 95% de Los pedidos se preparan martes entregan los
                miércoles
            </p>
            <div class="c-datepicker-wrapper">
                <custom-date-picker v-model="date" :block-to="blockToDate"></custom-date-picker>
            </div>
        </div>
        <template v-slot:columnExtraData>
            <btn-next :disabled-next="disabledNext" @click="goNext" :url-back="route('custom.type-select')"></btn-next>
        </template>
    </custom-container-full>
</template>

<script>
    import CustomContainerFull from "./CustomContainerFull";
    import BtnNext from "./BtnNext";
    import CustomDatePicker from "./CustomDatePicker";

    export default {
        name: "WeekSelect",
        components: {
            CustomDatePicker,
            CustomContainerFull,
            BtnNext
        },
        props: {
            budgetData: {
                type: Object
            }
        },
        data() {
            return {
                date: null,
                saving: false
            }
        },
        computed: {
            disabledNext() {
                return !this.date || this.saving;
            },
            blockToDate() {
                return moment(this.budgetData.block_to_date).toDate();
            }
        },
        watch: {
            budgetData() {
                this.setBudgetData();
            }
        },
        methods: {
            setBudgetData() {
                this.date = this.budgetData.date;
            },
            goNext() {
                let vm = this;
                vm.saving = true;
                let formData = new FormData();
                formData.append('date', vm.date);
                formData.append('id', vm.budgetData.id);
                axios.post(vm.route('custom.week-select-next'), formData).then((response) => {
                    window.location = vm.route('custom.index');
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                }).finally(() => {
                    vm.saving = false;
                });
            }
        },
        created() {
            this.setBudgetData();
        }
    }
</script>

<style scoped>
    .c-question {
        font-weight: bold;
        font-size: 1.25rem;
    }
    .c-question-first {
        padding-top: 1.2em;
    }

    @media (min-width: 992px) {
        .main-week-select {
            padding-bottom: 1rem;
        }

        .c-datepicker-wrapper {
            margin-top: 1.5em;
            margin-bottom: 1.5em;
        }

        .c-question-first {
            padding-top: 2.2em;
        }

        .c-question {
            padding-bottom: 0.8em;
        }
    }
</style>
